module.exports = __webpack_public_path__ + "static/teach-map-7b53f9d0e15c2acaa6a908dc471854c1.png";